import React, { useState } from "react";
import HeaderMobile from "./HeaderMobile";
import Header from "./Header";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import { BASE_URL } from "./Constants.js";

const GRNReportDownload = () => {

  const [city, setCity] = useState("");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const handleToggleSidebar = () => {
    if (window.innerWidth >= 992) {
      setIsSidebarOpen(prev => !prev);
    }
  };

const handleDownload = async (e) => {
  const cityId = e.target.value;
  setCity(cityId);

  if (!cityId) return;

  try {

    const token = localStorage.getItem("authToken");

    const response = await fetch(
      `${BASE_URL}grn_reports/${cityId}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error("API request failed");
    }

    const result = await response.json();

    if (!result.data || result.data.length === 0) {
      alert("No data found");
      return;
    }

    const rows = result.data;

    const headers = Object.keys(rows[0]);

    const csvRows = [
      headers.join(","),
      ...rows.map(row =>
        headers.map(field => `"${row[field] ?? ""}"`).join(",")
      )
    ];

    const csvString = csvRows.join("\n");

    const blob = new Blob([csvString], {
      type: "text/csv;charset=utf-8;",
    });

    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = `GRN_Report_${cityId}.csv`;

    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);

  } catch (error) {
    console.error("Download Error:", error);
    alert("Failed to download report");
  }
};
  return (
    <div className="page-wrapper">

      <HeaderMobile />

      <Sidebar isOpen={isSidebarOpen} />

      <div
        className="page-container"
        style={{
          marginLeft: isSidebarOpen && window.innerWidth >= 992 ? "250px" : "0",
          transition: "margin-left 0.3s ease"
        }}
      >

        <Header
          onToggleSidebar={handleToggleSidebar}
          isSidebarOpen={isSidebarOpen}
        />

        <div className="main-content">
          <div className="section__content section__content--p30">
            <div className="container-fluid">

              <div className="row">
                <div className="col-lg-12">

                  <div className="card">
                    <div className="card-header">
                      <h3>Download GRN Report</h3>
                    </div>

                    <div className="card-body">

                      <div style={{ maxWidth: "300px" }}>

                        <label><b>Select City</b></label>

                        <select
                          className="form-control"
                          value={city}
                          onChange={handleDownload}
                        >
                          <option value="">Select City</option>
                          <option value="1">Hyderabad</option>
                          <option value="2">Pune</option>
                          <option value="3">Kolkata</option>
                          <option value="4">Bangalore</option>
                          <option value="12">Kurnool</option>
                          <option value="13">Vizag</option>
                          
                        </select>

                      </div>

                      <p style={{ marginTop: "15px", color: "#666" }}>
                        Selecting a city will download the GRN report in CSV format.
                      </p>

                    </div>
                  </div>

                </div>
              </div>

            </div>
          </div>
        </div>

      </div>

      <Footer />

    </div>
  );
};

export default GRNReportDownload;